import Api from '../../../api/configuration'

const PaymentApis = {
  createTransaction: (billId, mode, subscriptionId) =>
    Api.coreProtected.post(`payment/start/v3`, {
      billId,
      paymentGateway: mode,
      subscriptionId,
      newKeys: true,
    }),
  processTransaction: (billId, mode, data) =>
    Api.coreProtected.post(`payment/end`, {
      billId,
      paymentGateway: mode,
      pgData: data,
      newKeys: true,
    }),
  redeemDiscountCoupon: (billId, code) =>
    Api.coreProtected.put(`payment/coupon/redeem`, {
      billId,
      code,
    }),
  removeDiscountCoupon: (billId) =>
    Api.coreProtected.put(`payment/coupon/de-redeem`, {
      billId,
    }),
}

export default PaymentApis
